// import React, { useState, useEffect } from 'react';
// import { PieChart, Pie, Cell, ResponsiveContainer, Label, Legend, Sector } from 'recharts';
// import { Box, useMediaQuery } from '@mui/material';
// import './ExpensePieChart.css';

// const ExpensePieChart = () => {
//   const [activeIndex, setActiveIndex] = useState(null);
//   const [pieChartData, setPieChartData] = useState([]);
//   const [totalSpend, setTotalSpend] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const isSmallScreen = useMediaQuery('(max-width:1024px)');

//   useEffect(() => {
//     const fetchPieChartData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch('http://127.0.0.1:8000/dashboard/pie-chart-data'); // Replace with your API endpoint
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const data = await response.json();

//         // Transform the API data to match the format required by the Pie chart
//         const formattedData = data.map((item) => ({
//           name: item.category_name,
//           value: item.total_amount,
//           // color: item.color, // Ensure your API returns a color field or assign it dynamically
//         }));

//         setPieChartData(formattedData);

//         // Calculate the total spend
//         const total = formattedData.reduce((acc, item) => acc + item.value, 0);
//         setTotalSpend(total);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPieChartData();
//   }, []);

//   const onPieEnter = (_, index) => setActiveIndex(index);
//   const onPieLeave = () => setActiveIndex(null);

//   const renderCustomizedLabel = (props) => {
//     const { cx, cy, midAngle, outerRadius, index } = props;
//     if (index !== activeIndex) return null;

//     const RADIAN = Math.PI / 180;
//     const radius = outerRadius + 50; // Distance from the pie
//     const x = cx + radius * Math.cos(-midAngle * RADIAN);
//     const y = cy + radius * Math.sin(-midAngle * RADIAN);

//     const labelText = pieChartData[index]?.name || '';

//     return (
//       <g>
//         <line
//           x1={cx + (outerRadius + 10) * Math.cos(-midAngle * RADIAN)}
//           y1={cy + (outerRadius + 10) * Math.sin(-midAngle * RADIAN)}
//           x2={x}
//           y2={y}
//           stroke="#000"
//           strokeWidth={2}
//         />
//         <text
//           x={x}
//           y={y}
//           fill="#000"
//           textAnchor={x > cx ? 'start' : 'end'}
//           dominantBaseline="central"
//           fontSize={14}
//           fontWeight={500}
//         >
//           {labelText}
//         </text>
//       </g>
//     );
//   };

//   const renderActiveShape = (props) => {
//     const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
//     return (
//       <Sector
//         cx={cx}
//         cy={cy}
//         innerRadius={innerRadius}
//         outerRadius={outerRadius + 10}
//         startAngle={startAngle}
//         endAngle={endAngle}
//         fill={fill}
//       />
//     );
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <Box
//       sx={{
//         margin: '35px',
//         padding: { xs: 2, sm: 3 },
//         backgroundColor: '#f8f9fa',
//         borderRadius: 2,
//         boxShadow: 2,
//         marginLeft: { xs: '-30px', sm: '35px' },
//       }}
//     >
//       <ResponsiveContainer width="100%" height={400}>
//         <PieChart>
//           <Pie
//             data={pieChartData}
//             dataKey="value"
//             nameKey="name"
//             cx="50%" // Center horizontally
//             cy="50%" // Center vertically
//             innerRadius={80}
//             outerRadius={120}
//             activeIndex={activeIndex}
//             activeShape={renderActiveShape}
//             onMouseEnter={onPieEnter}
//             onMouseLeave={onPieLeave}
//             label={renderCustomizedLabel}
//           >
//             {pieChartData.map((entry, index) => (
//               <Cell key={`cell-${index}`} fill={entry.color} />
//             ))}
//             <Label
//               value={`Total Spend\n₹ ${totalSpend.toLocaleString()}`}
//               position="center"
//               className="total-spend-label"
//             />
//           </Pie>
//           <Legend
//             layout={isSmallScreen ? 'horizontal' : 'vertical'}
//             verticalAlign={isSmallScreen ? 'bottom' : 'middle'}
//             align={isSmallScreen ? 'center' : 'left'}
//             wrapperStyle={{
//               display: 'flex',
//               justifyContent: isSmallScreen ? 'center' : 'flex-start',
//               flexWrap: isSmallScreen ? 'nowrap' : 'wrap',
//               marginTop: isSmallScreen ? '20px' : '0',
//             }}
//             payload={pieChartData.map((item) => ({
//               value: item.name,
//               type: 'square',
//               color: item.color,
//             }))}
//           />
//         </PieChart>
//       </ResponsiveContainer>
//     </Box>
//   );
// };

// export default ExpensePieChart;


import React, { useState, useEffect } from "react";
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Sector } from "recharts";
import { Box, Paper } from "@mui/material";

const CATEGORY_COLORS = {
  car: "#f44336",
  Electricity: "#2979ff",
  Stationery: "#ffb300",
  Cloth: "#ab47bc",
  Groceries: "#2196f3",
  Electricities: "#407538",
  "Grocery Store": "#00ab66",
  Electronics: "#9c27b0",
  Gym: "#ff5722",
  Furniture: "#3f51b5",
  Chair: "#009688",
  Electronic: "#795548",
  Photography: "#673ab7",
  Cars: "#e91e63",
  Photo: "#4caf50",
  Bike: "#ffc107",
  Photographer: "#607d8b",
  Salonnn: "#8bc34a",
};

const ExpensePieChart = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [pieChartData, setPieChartData] = useState([]);
  const [totalSpend, setTotalSpend] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPieChartData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "http://127.0.0.1:8000/dashboard/pie-chart-data"
        );
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();

        const categoryMap = new Map();

        data.forEach((item) => {
          const normalized = item.category_name.trim(); 
          if (categoryMap.has(normalized)) {
            categoryMap.get(normalized).value += item.total_amount;
          } else {
            categoryMap.set(normalized, {
              name: normalized,
              value: item.total_amount,
              color: CATEGORY_COLORS[normalized] || "#999999", 
            });
          }
        });

        const formattedData = Array.from(categoryMap.values());

        setPieChartData(formattedData);
        setTotalSpend(formattedData.reduce((acc, item) => acc + item.value, 0));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPieChartData();
  }, []);

  const onPieEnter = (_, index) => setActiveIndex(index);
  const onPieLeave = () => setActiveIndex(null);

  const renderCustomizedLabel = ({ cx, cy, midAngle, outerRadius, index }) => {
    if (index !== activeIndex) return null;

    const RADIAN = Math.PI / 180;
    const radius = outerRadius + 50;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <g>
        <line
          x1={cx + (outerRadius + 10) * Math.cos(-midAngle * RADIAN)}
          y1={cy + (outerRadius + 10) * Math.sin(-midAngle * RADIAN)}
          x2={x}
          y2={y}
          stroke="#000"
          strokeWidth={2}
        />
        <text
          x={x}
          y={y}
          fill="#000"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
          fontSize={14}
          fontWeight={500}
        >
          {pieChartData[index]?.name}
        </text>
      </g>
    );
  };

  const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } =
      props;
    return (
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 10}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    );
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 3,
        m: 4,
        ml: { xs: "-30px", sm: "35px" },
        display: "flex",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignContent: "flex-start",
          maxHeight: 350,
          overflowY: "auto",
        }}
      >
        {pieChartData.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              width: "calc(20% - 5px)", 
              minWidth: 120,
            }}
          >
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: "4px",
                bgcolor: item.color,
                mr: 1,
              }}
            />
            <Box sx={{ fontSize: 13, fontWeight: 500 }}>{item.name}</Box>
          </Box>
        ))}
      </Box>

      {/* Pie Chart */}
      <Box sx={{ flex: 1, height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieChartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={80}
              outerRadius={120}
              activeIndex={activeIndex}
              activeShape={renderActiveShape}
              onMouseEnter={onPieEnter}
              onMouseLeave={onPieLeave}
              label={renderCustomizedLabel}
            >
              {pieChartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
              <Label
                value={`Total Spend\n₹ ${totalSpend.toLocaleString()}`}
                position="center"
                style={{
                  fontFamily: "Poppins",
                  fontSize: 16,
                  fill: "#333",
                  whiteSpace: "pre-line",
                  textAlign: "center",
                }}
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default ExpensePieChart;

